import { bindActionCreators } from '@reduxjs/toolkit';
import { useState } from 'react';
import { GoogleReCaptcha, GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { listConstants } from '../../../app/modules/Constants/_constants.service';
import {
    getCompany,
    getCompanyConfig,
    getCompanySettings,
} from '../../../app/modules/Unr/_unr.service';
import { creators } from '../../../app/state';
import { getUserByToken, login } from '../core/_requests';
import { useAuth } from '../core/Auth';

const AutoLogin = () => {
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const [recaptcha, setRecaptcha] = useState('');
    const { saveAuth, setCurrentUser } = useAuth();
    const dispatch = useDispatch();
    const { setConstants } = bindActionCreators(creators, dispatch);
    const navigate = useNavigate();

    const initLogin = async () => {
        setLoading(true);
        try {
            const { data: auth } = await login(
                searchParams.get('username'),
                searchParams.get('password'),
                recaptcha
            );
            saveAuth(auth);
            const { data: user } = await getUserByToken(true);
            if (!user.company) {
                user.company = {};
            }
            if (user.company_id) {
                user.company = await getCompany(user.company_id, { active_services: true });
                if (!user.company) {
                    user.company = {};
                }
                user.company.config = await getCompanyConfig(
                    user?.company?.owned_by || user?.company_id
                );

                const brandConfig = await getCompanySettings('brand_settings', user.company_id);
                user.company.brand = brandConfig?.data;
            }
            setCurrentUser(user);
            await initConstants();
            // navigate('/');
        } catch (error) {
            saveAuth(undefined);
            setLoading(false);
        }
    };
    initLogin();

    const initConstants = async () => {
        const data = await listConstants();
        setConstants(data);
    };

    return (
        <div>
            <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_ID}>
                <GoogleReCaptcha
                    onVerify={(token) => {
                        setRecaptcha(token);
                    }}
                />
            </GoogleReCaptchaProvider>
            {loading && (
                <span
                    className='indicator-progress'
                    style={{ display: 'block' }}>
                    Please wait...
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
            )}
        </div>
    );
};
export default AutoLogin;
